import devicesModule from '@/store/modules/devices.module'
import geofencesModule from '@/store/modules/geofences.module'
import Map from 'ol/Map'
import View from 'ol/View'
import { defaults as defaultControls } from 'ol/control'
import TileLayer from 'ol/layer/Tile'
import { fromLonLat } from 'ol/proj'
import OSM from 'ol/source/OSM'
import XYZ from 'ol/source/XYZ'
import VectorService from '../vector.service'
import CenterAllControl from './controls/center-all.control'
import ChangeMapControl from './controls/change-map.control'
import EraseAllControl from './controls/erase-all.control'
import RasterControl from './controls/raster.control'
import CircleGeofenceFeature from './features/circle-geofence.feature'
import DeviceFeature from './features/device.feature'
import PolygonGeofenceFeature from './features/polygon-geofence.feature'
import RasterFeature from './features/raster.feature'

export default class MapsService {
    map: Map = new Map()

    init() {
        this.map = this.initMap()
    }

    updateIconsDevices() {
        VectorService.clearVectorSource(5)
        const features = devicesModule.devices.map((device) => {
            return new DeviceFeature(device).create()
        })
        VectorService.insertFeatures(5, features)
    }

    updateRasterDevices() {
        VectorService.clearVectorSource(3)
        const features = devicesModule.devices.map((device, index) => {
            return new RasterFeature(device, index).create()
        })
        VectorService.insertFeatures(3, features)
    }

    updateGeofences() {
        VectorService.clearVectorSource(2)
        const features = geofencesModule.geofences.flatMap((geofence) => {
            if (geofence.area.includes('CIRCLE')) {
                const feature = new CircleGeofenceFeature(geofence)
                return [feature.getCenterFeature(), feature.create()]
            } else {
                const feature = new PolygonGeofenceFeature(geofence)
                return [feature.getCenterFeature(), feature.create()]
            }
        })
        VectorService.insertFeatures(2, features)
    }

    centerPoint(position: { longitude: number; latitude: number }) {
        this.map.getView().setZoom(17)
        this.map.getView().setCenter(fromLonLat([position.longitude, position.latitude]))
    }

    changeMap(mapName: string) {
        this.map
            .getLayers()
            .getArray()
            .filter((layer) => layer.getClassName() == 'bingmaps' || layer.getClassName() == 'ostm')
            .forEach((e) => e.setVisible(e.getClassName() == mapName))
    }

    initMap() {
        const view = new View({
            center: fromLonLat([-77.0334, -12.0655]), //center in Lima
            zoom: 11,
            maxZoom: 19,
            minZoom: 1,
        })
        return new Map({
            target: 'principalMap',
            controls: defaultControls({ attribution: false }).extend([
                new ChangeMapControl(),
                new CenterAllControl(),
                new RasterControl(),
                new EraseAllControl(),
            ]),
            view,
            layers: [
                new TileLayer({
                    source: new OSM({ cacheSize: 5000 }),
                    visible: true,
                    className: 'ostm',
                }),
                new TileLayer({
                    source: new XYZ({
                        url: `https://api.maptiler.com/tiles/satellite-v2/{z}/{x}/{y}.jpg?key=CrLHLVHG192Vk8XOYKzi`,
                        tileSize: 512,
                        crossOrigin: 'anonymous',
                        cacheSize: 5000,
                        attributions: '© MapTiler',
                        maxZoom: 19,
                    }),
                    visible: false,
                    className: 'bingmaps',
                    maxZoom: 19,
                }),
                VectorService.createVectorBase('geofences'), //vector 2
                VectorService.createVectorBase('raster'), //vector 3
                VectorService.createVectorBase('reports'), //vector 4
                VectorService.createVectorBase('icons-devices'), //vector 5
                VectorService.createVectorBase('icons-alerts'), //vector 6
            ],
        })
    }
}
